import React, { useState } from "react";

/**
 * FDP 3D brand mark. This component is intentionally NOT a link — the parent
 * decides where clicking should navigate:
 *   - Navbar (main app): external → fabricadeprofile.ro (new tab)
 *   - Login / Register / VerifyEmail pages: local → / (landing)
 *
 * The image is served from the SAME origin (`/brand/...`) so it can never
 * be blocked by ad-blockers or third-party tracking-protection lists.
 *
 * iter96.1 · Text switched from "FDP" (with subtitle) to "FDP 3D" — cleaner
 * short name for the 3D-visualization service.
 */
export const FDP_LOGO_URL = "/brand/fdp-logo-official.png";
export const FDP_LOGO_FALLBACK = "/brand/fdp-logo-orange.png";

export default function Logo({ className = "h-9 w-auto", showText = true }) {
  const [src, setSrc] = useState(FDP_LOGO_URL);
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="FDP — Fabrica de Profile"
        className="h-9 w-9 object-contain rounded-sm"
        onError={() => {
          if (src !== FDP_LOGO_FALLBACK) setSrc(FDP_LOGO_FALLBACK);
        }}
      />
      {showText && (
        <span className="font-manrope text-[17px] font-extrabold tracking-tight inline-flex items-baseline">
          <span className="text-orange-500">FDP</span>
          <span className="text-white ml-1">3D</span>
        </span>
      )}
    </div>
  );
}
